/*
Copyright 2026 QonGroup GmbH.

SPDX-License-Identifier: AGPL-3.0-only
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { Heading, Text } from "@vector-im/compound-web";

import { FullScreenView } from "./FullScreenView";
import styles from "./InviteOnlyView.module.css";

export const InviteOnlyView: FC = () => (
  <FullScreenView>
    <main className={styles.main}>
      <Text className={styles.eyebrow}>QONGROUP</Text>
      <Heading size="xl" weight="semibold">
        QonGroup Video
      </Heading>
      <Text className={styles.copy}>
        Bitte öffne deinen persönlichen Einladungslink, um einem Gespräch
        beizutreten.
      </Text>
    </main>
  </FullScreenView>
);
